import { Avatar, CardContent, CardHeader } from '@mui/material';
import { LoadingCard } from '../LoadingCard';
import { useLocationEmployeeRanksQuery } from '@features/redux/apis/org';
import { useMemo } from 'react';
import { EmployeeEffects } from './EmployeeEffects';

type EmployeeRankCardProps = {
    employeeEmail: string;
    locationId: number;
    startDate?: string;
    endDate?: string;
};

export const EmployeeRankCard = ({ employeeEmail, locationId, ...dates }: EmployeeRankCardProps) => {
    const queryState = useLocationEmployeeRanksQuery({
        LocationID: locationId,
        ...dates,
    });
    const { data: employeeRanks, isFetching: loading } = queryState;

    const employeeRank = useMemo(
        () => employeeRanks?.find(({ EmployeeEmail }) => EmployeeEmail === employeeEmail)?.Rank,
        [employeeRanks]
    );

    return (
        <>
            <EmployeeEffects queryState={queryState} typeOfData='ranks' />

            <LoadingCard
                loading={loading}
                sx={{ height: '100%', flexDirection: { xs: 'column', sm: 'row', md: 'row', lg: 'row', xl: 'row' } }}>
                <CardContent
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}>
                    <Avatar sx={{ width: '65px', height: '65px', fontSize: '32px', fontWeight: 'bold' }}>
                        #{employeeRank || '?'}
                    </Avatar>
                </CardContent>

                <CardHeader title='Rank at Location' subheader='By total # of cuts' />
            </LoadingCard>
        </>
    );
};
